import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multisourcevariantfilter',
})
export class MultiSourceVariantFilter implements PipeTransform {
  transform(objects: any, exclude: any): any {
    if (objects) {
      // filter out the variants we don't want on this particular component from the 5 sizes provided by Strapi
      return objects.filter((el) => {
        return !exclude.some((f) => {
          return f.name === el.name;
        });
      });
    }
  }
}
